module.exports = __webpack_public_path__ + "img/mix-1.15d1b91b.jpg";